/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';

import APP_CONSTANTS from '../../config/constants';



const BranchDropdown = ({
    field: { name },
    form: { setFieldValue },
    getMasterBranchSelected,
    ...props
}) => {

    const [branch, setBranch] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')
        let data = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}masters/branch`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setBranch(response.data.resultSet)
            /* if ((purchaseOrderDetails != null && purchaseOrderDetails != undefined) && purchaseOrderDetails?.[0]?.branchId)
                getMasterBranchSelected(purchaseOrderDetails[0].branchId, response.data.resultSet) */
            setIsLoading(false)
        }))
            .catch(error => console.log(error))
        setIsLoading(false)
    }, [])


    let options = []
    if (branch && branch.length > 0) {
        branch.map((object, index) => {
            let temp = {}
            temp.key = object.branchCode
            temp.text = `${object.branchName} (${object.branchCode})`
            temp.value = object.branchId
            temp.extra = object
            return options[index] = temp
        })
    }

    // const handleOnChange = (e, data) => {
    //     setFieldValue(name, data.value);
    //     getBranchSelected(data.value);
    // }

    return (
        <Dropdown
            selection
            search
            onChange={(value, data) => { setFieldValue(name, data.value); getMasterBranchSelected(data.value, branch, setFieldValue); console.log("Data======>Brnach", data, value) }}
            options={options}
            loading={isLoading}
            {...props}
            fluid
        />

    )
}

export default BranchDropdown